import React from 'react'
import {OfferBox} from 'components/OfferBox/OfferBox'
import {useOtaMode} from 'hooks/useOtaMode'

import {Box} from '@vio/atlas/helpers/Box'

import {BoVioFirstCardLoading} from './ExperimentalBoVioFirstCard/HotelCardLoading'
import {GalleryLoading} from './Gallery/GalleryLoading'
import {HotelCardLayout} from './HotelCardLayout/HotelCardLayout'
import {HOTEL_CARD_MAX_WIDTH} from './HotelCardMobile'
import {PropertySummaryLoading} from './PropertySummary/PropertySummaryLoading'

export const HotelCardMobileLoading = () => {
  const {isOTAMode, isBoVioEnvironment} = useOtaMode()

  if (isBoVioEnvironment) {
    return <BoVioFirstCardLoading isOTAMode={isOTAMode} />
  }

  return (
    <Box
      maxWidth={`${HOTEL_CARD_MAX_WIDTH}px`}
      margin="0 auto"
      paddingBottom="s500"
    >
      <HotelCardLayout
        isTopOfferMemberDeal={false}
        onClick={() => ({})}
        gallerySlot={<GalleryLoading />}
        propertySummarySlot={<PropertySummaryLoading />}
        basicPropertyDetailsSlot={null}
        filtersMatchSlot={null}
        watchButtonSlot={null}
        offersSlot={
          <OfferBox
            isLoading
            withHotelCard
            primaryOfferVariant="PrimaryMultiColumn"
            shouldHideSecondaryOffers={isOTAMode}
          />
        }
      />
    </Box>
  )
}
